import React from 'react';

import TrackableFeature from './TrackableFeature';

const withTrackableFeature = opts => Comp => props => (
  <TrackableFeature {...opts}>
    <Comp {...props} />
  </TrackableFeature>
);

export default withTrackableFeature;
